import React, { Component } from 'react';
import IteamAudioPlayerComponent from '../components/IteamAudioPlayerComponent';
import IteamBooksMenuComponent from '../components/IteamBooksMenuComponent';
import IteamNumKeypadComponent from '../components/IteamNumKeypadComponent';
import IteamUnitsMenuComponent from '../components/IteamUnitsMenuComponent';
import IteamVideoPlayerComponent from '../components/IteamVideoPlayerComponent';


class IteamFooterPageNavBar extends Component {
    constructor(props) {
        super(props);
        this.state = {isNumericKeypadShown: false,
                      isUnitsMenuShown: false,
                      isBooksMenuShown: false
                     };

        this.showNumericKeyPad = this.showNumericKeyPad.bind(this);
        this.showUnitsMenu = this.showUnitsMenu.bind(this);
        this.showBooksMenu = this.showBooksMenu.bind(this);

        this.navigateToNextPageHandler = this.navigateToNextPageHandler.bind(this);
        this.navigateToPrevPageHandler = this.navigateToPrevPageHandler.bind(this);

        this.numericKeyPadButton = React.createRef();
        this.unitsButton = React.createRef();
        this.booksButton = React.createRef();
    }


    showNumericKeyPad() {
        if (this.state.isNumericKeypadShown) {
            this.setState({isNumericKeypadShown: false});
        } else {
            if (this.state.isBooksMenuShown) {
                this.setState({isBooksMenuShown: false});
            } 
            if (this.state.isUnitsMenuShown) {
                this.setState({isUnitsMenuShown: false});
            } 
            this.setState({isNumericKeypadShown: true});
        }
    }

    showUnitsMenu() {
        if (this.state.isUnitsMenuShown) {
            this.setState({isUnitsMenuShown: false});
        } else {
            if (this.state.isBooksMenuShown) {
                this.setState({isBooksMenuShown: false});
            } 
            if (this.state.isNumericKeypadShown) {
                this.setState({isNumericKeypadShown: false});
            } 
            this.setState({isUnitsMenuShown: true});
        }
    }

    showBooksMenu() {
        if (this.state.isBooksMenuShown) {
            this.setState({isBooksMenuShown: false});
        } else {
            if (this.state.isUnitsMenuShown) {
                this.setState({isUnitsMenuShown: false});
            } 
            if (this.state.isNumericKeypadShown) {
                this.setState({isNumericKeypadShown: false});
            } 
            this.setState({isBooksMenuShown: true});
        }
    }

    navigateToPrevPageHandler() {
        if (this.state.isNumericKeypadShown) {
            this.setState({isNumericKeypadShown: false});
        } 
        if (this.state.isUnitsMenuShown) {
            this.setState({isUnitsMenuShown: false});
        } 
        if (this.state.isBooksMenuShown) {
            this.setState({isBooksMenuShown: false});
        } 
        this.props.navigateToPrevPageHandler();
    }

    navigateToNextPageHandler() {

        if (this.state.isNumericKeypadShown) {
            this.setState({isNumericKeypadShown: false});
        } 
        if (this.state.isUnitsMenuShown) {
            this.setState({isUnitsMenuShown: false});
        } 
        if (this.state.isBooksMenuShown) {
            this.setState({isBooksMenuShown: false});
        } 
        this.props.navigateToNextPageHandler();
    }

    render() {
        let numericKeyPadComponent = '';
        if (this.state.isNumericKeypadShown) {
            numericKeyPadComponent = (<IteamNumKeypadComponent showNumericKeyPad={this.showNumericKeyPad} 
                                            numButtonLeft={this.numericKeyPadButton.current.offsetLeft} 
                                            numButtonWidth={this.numericKeyPadButton.current.offsetWidth} 
                                            gotoPageNumber={this.props.gotoPageNumber}
                                            disableGameInputsCallback={this.props.disableGameInputsCallback}
                                            enableGameInputsCallback={this.props.enableGameInputsCallback}
                                        />);
        }

        let unitsMenuComponent = '';
        if (this.state.isUnitsMenuShown) {
            unitsMenuComponent = (<IteamUnitsMenuComponent showUnitsMenu={this.showUnitsMenu} 
                                            unitsButtonLeft={this.unitsButton.current.offsetLeft} 
                                            units={this.props.units}
                                            navigateToChapterIndex={this.props.navigateToChapterIndex}
                                            disableGameInputsCallback={this.props.disableGameInputsCallback}
                                            enableGameInputsCallback={this.props.enableGameInputsCallback}
                                    />);
        }

        let booksMenuComponent = '';
        if (this.state.isBooksMenuShown) {
            booksMenuComponent = (<IteamBooksMenuComponent showBooksMenu={this.showBooksMenu} 
                                        sectionsAndBooks={this.props.sectionsAndBooks}
                                        loadSectionHandler={this.props.loadSectionHandler}
                                        disableGameInputsCallback={this.props.disableGameInputsCallback}
                                        enableGameInputsCallback={this.props.enableGameInputsCallback}
                                    />);
        }

        let audiovideocomponent = '';
        if (this.props.pageAudioDM !== undefined && this.props.pageAudioDM !== null) {
            audiovideocomponent = (<IteamAudioPlayerComponent 
                                    setPagePauseAudioCallback={this.props.setPagePauseAudioCallback}
                                    audiourl={this.props.pageAudioDM.src} />);
        }

        if (this.props.pageVideoDM !== undefined && this.props.pageVideoDM !== null) {
            audiovideocomponent = (<div><IteamVideoPlayerComponent
                                    setPagePauseVideoCallback={this.props.setPagePauseVideoCallback}
                                    videourl={this.props.pageVideoDM.src} /></div>);
        }

        let showPageNavButtons = true;
        if (this.props.loadedSectionItem !== undefined && this.props.loadedSectionItem !== null) {
            if (this.props.loadedSectionItem.type !== undefined && (this.props.loadedSectionItem.type === 'dictionary' || this.props.loadedSectionItem.type === 'game')) {
                showPageNavButtons = false;
            }
        }

        return (<div className='pageNavigationBar'>
        {showPageNavButtons ? <div className='iTeamPageNavBarButtons'>
            <div className='iTeamBtnNavPrevPageContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.navigateToPrevPageHandler}>
                    <svg viewBox="0 0 200 200"><path d="M0,99.74A27.56,27.56,0,0,0,19.19,126.3l140.92,70.79a27.67,27.67,0,0,0,24.67-49.54l-95-47.7,95-47.48A27.66,27.66,0,0,0,160.06,2.88L19.72,73A27.55,27.55,0,0,0,0,99.74Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnNavNumPadContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.showNumericKeyPad} ref={this.numericKeyPadButton}>
                    <svg viewBox="0 0 200 200"><circle cx="25.58" cy="25.58" r="25.58"/><circle cx="100" cy="25.58" r="25.58"/><circle cx="174.42" cy="25.58" r="25.58"/><circle cx="25.58" cy="100" r="25.58"/><circle cx="100" cy="100" r="25.58"/><circle cx="174.42" cy="100" r="25.58"/><circle cx="25.58" cy="174.42" r="25.58"/><circle cx="100" cy="174.42" r="25.58"/><circle cx="174.42" cy="174.42" r="25.58"/></svg>
                </button>
            </div>
            <div className='iTeamBtnNavNextPageContainer iTeamFooterBtnContainer'>
                <button className='btnFooter' onClick={this.navigateToNextPageHandler}>
                    <svg viewBox="0 0 200 200"><path d="M200,100.26A27.56,27.56,0,0,0,180.81,73.7L39.89,2.91A27.67,27.67,0,0,0,15.22,52.45l95,47.7-95,47.48a27.66,27.66,0,0,0,24.74,49.49L180.28,127A27.55,27.55,0,0,0,200,100.26Z"/></svg>
                </button>
            </div>
            <div className='iTeamBtnUnitsPageContainer iTeamFooterBtnContainer'>
                <button className='btnFooterText menuOpenerButtonLargeFont' 
                        onClick={this.showUnitsMenu}
                        ref={this.unitsButton}>
                    UNITS
                </button>
            </div>
        </div> : ''}
        <div className='iTeamFooterSpaceFillerContainer iTeamAudioVideoContainer'>
            {audiovideocomponent}
        </div>
        <div className='iTeamBtnBooksPageContainer iTeamFooterBtnContainer'>
            <button className='btnFooterText menuOpenerButtonLargeFont'
                    onClick={this.showBooksMenu}
                    ref={this.booksButton}>
                MENU
            </button>
        </div>
        {numericKeyPadComponent}
        {unitsMenuComponent}
        {booksMenuComponent}
        </div>);
    }
}

export default IteamFooterPageNavBar;